/**
 * Find / replace FormulaPendingChip nodes in the TipTap editor.
 */

import { toTipTapTextContent } from "./insertHtmlIntoReportEditor";

/**
 * @param {object} editor - TipTap editor (or RTE wrapper with state/chain)
 * @param {string} calculationId
 * @returns {{ from: number, to: number } | null}
 */
export function findFormulaPendingChipRange(editor, calculationId) {
  if (!editor?.state?.doc || calculationId == null || calculationId === "") {
    return null;
  }
  const id = String(calculationId);
  let found = null;
  editor.state.doc.descendants((node, pos) => {
    if (found) return false;
    if (
      node.type?.name === "formulaPendingChip" &&
      String(node.attrs?.calculationId) === id
    ) {
      found = { from: pos, to: pos + node.nodeSize };
      return false;
    }
    return true;
  });
  return found;
}

/**
 * Replace a pending chip with plain TipTap text. Returns false if chip not found.
 * @param {object} editor
 * @param {string} calculationId
 * @param {string} text
 * @param {Function} [setTranscript]
 * @returns {boolean}
 */
export function replaceFormulaPendingChipWithText(
  editor,
  calculationId,
  text,
  setTranscript,
) {
  const range = findFormulaPendingChipRange(editor, calculationId);
  if (!range || !editor?.chain) return false;
  const content = toTipTapTextContent(text);
  if (!content.text) return false;

  const ok = editor
    .chain()
    .insertContentAt(range, content, { updateSelection: false })
    .run();

  if (ok !== false && typeof setTranscript === "function") {
    const html =
      typeof editor.getHTML === "function"
        ? editor.getHTML()
        : typeof editor.getContents === "function"
          ? editor.getContents()
          : null;
    if (html != null) setTranscript(html);
  }
  return ok !== false;
}
